<template>
    <v-autocomplete
        v-model="currentBranch"
        outlined 
        :items="userBranch"
        return-object
        item-text="name"
        item-value="value"
        label="สาขา">
    </v-autocomplete>
</template>

<script>
import {listDropdownUserBranch} from '@/api/common/dropdown-api.js'
import {getUsername} from '@/assets/js/common.js'

export default {
    name: 'UserBranchDropdown',
    props: ["pageCode"],
    watch: {
        currentBranch(data) {
            if (data == null || data == 'undefined') return;
            localStorage.setItem("currBranchCode", data.value);
            localStorage.setItem("currBranchName", data.name);
            this.$emit('onUserBranchChange', data.value);
            this.$emit('onUserBranchNameChange', data.name);
        }
    },
    data: () => ({
        currentBranch: {},
        userBranch: []
    }),
    mounted() {
        this.userBranch = [];
        this.$loading(true);
        listDropdownUserBranch(getUsername(), this.pageCode).then(rs => {
            this.$loading(false);
            this.userBranch = rs;
            if (this.userBranch) {
                let selectedBranch = localStorage.getItem("currBranchCode");
                let selectedBranchName = localStorage.getItem("currBranchName");
                let obj = {name: selectedBranchName, value: selectedBranch};
                let isExists = this.userBranch.filter(o => o.value == selectedBranch).length > 0;
                this.currentBranch = !isExists || selectedBranch == null || selectedBranch == 'undefined' ? this.userBranch[0] : obj;
            }
        }).catch(() => {
            this.$loading(false);
        });
        
    }
}
</script>